module.exports = __webpack_public_path__ + "static/media/kindboost.fabaa914.svg";